import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Helmet from 'react-helmet';
import { usePage } from '@inertiajs/inertia-react';
import { InertiaLink } from '@inertiajs/inertia-react';
import SiteLayout from '@/Shared/SiteLayout';
import Pagination from '@/Shared/Pagination';

function Index() {
     const { app, info } = usePage().props;

     return (
          <React.Fragment>
               <Helmet>
                    <title>{`Medias`}</title>
               </Helmet>
               <section className="w-full bg-white pt-10 pb-10">
                    <div className="container mx-auto md:p-3">
                         <div className="w-full mt-10">
                              <h1 className="font-bold text-center text-4xl uppercase bg-clip-text text-emerald-700">Medias</h1>
                         </div>
                         <div className="p-4 grid grid-cols-1 gap-y-2 sm:grid-cols-2 sm:gap-2 md:grid-cols-3 md:gap-6 pt-10 pb-10">
                              {info.posts.data.map(({id, title, cover, category, published, url}) => {
                                   return <div key={id} className="mb-6 p-4 hover:bg-emerald-50 rounded-lg">
                                        <a href={route('blog.post.show', [id, url])} aria-label={title}>
                                             <img className="w-full mb-4 rounded-lg shadow-none transition transition-shadow duration-500 ease-in-out" src={cover} alt={title} />
                                             <div className="flex items-center mb-3">
                                                  <span className="inline-flex items-center px-3 py-0.5 rounded-full text-xs font-bold leading-5 text-yellow-700 font-display mr-2 capitalize bg-yellow-400">
                                                       {category}
                                                  </span>
                                                  <p className="text-xs font-normal opacity-75 text-emerald-800">{published}</p>
                                             </div>
                                             <p className="font-display max-w-sm text-2xl font-bold leading-tight">
                                                  <span className="text-slate-700 hover:text-emerald-600 hover:underline">
                                                       {title}
                                                  </span>
                                             </p>
                                        </a>
                                   </div>
                              })}
                         </div>
                         <div>
                              <Pagination links={info.posts.links} />
                         </div>
                    </div>
               </section>
          </React.Fragment>
     );
}

Index.layout = page => <SiteLayout children={page} header={'Index'} />;

export default Index;
